<template>
  <div class="legalNotices">
    <div class="section is-medium">
      <div class="container is-fluid">
        <div class="columns">
          <div class="column is-one-quarter">
            <h1 class="deneme">YASAL UYARI</h1>
          </div>
          <div class="column tile is-parent is-vertical is-8">
            <span class="">
              <ul>
                <li>
                  <p>Bu web sitesi (“Web Sitesi”), yalnızca genel bilgi sağlamak üzere tasarlanmıştır. İçeriğinin, Türkiye Barolar Birliği tarafından yayımlanan Mesleki Kurallar ve Reklam Yasağı Hakkındaki Yönetmeliği’ne uygun olması amaçlanmıştır.
                  </p>
                </li><br>
                <li>
                  <p>Web Sitesi’nde yer alan bilgiler, hukuki görüş verildiği veya avukat/müvekkil ilişkisi oluşturduğu şeklinde yorumlanmamalıdır.

                  </p>
                </li><br>
                <li>
                  <p>Sunulan bilgilerin doğru, eksiksiz veya güncel olduğu garanti edilmemekte ve Web Sitesi’nde sunulan bilgilerin doğruluğu, eksiksiz oluşu veya güncelliği konusunda herhangi bir taahhütte bulunulmamaktadır. 
                  </p>
                </li><br>
                <li>
                  <p>Sarıkaya + Şahin, Web Sitesi’nin ve içeriğinin tek ve yegâne sahibidir. Sarıkaya + Şahin’in yazılı olarak açıkça izin verdiği durumlar dışında Web Sitesi’nin veya içeriğin hiçbir kısmını herhangi bir ticari amaç için çoğaltmamayı, kopyalamamayı, satmamayı, tekrar satmamayı veya kendi çıkarınıza kullanmamayı kabul etmektesiniz. Web Sitesi’nde yer alan tüm haklar, ünvanlar ve menfaatlerin tek sahibinin Sarıkaya + Şahin olduğunu beyan ve taahhüt etmektesiniz. Web Sitesi’nin veya içeriğin kullanımının tüm şekilleri yasaktır.
                  </p>
                </li><br>
                <li>
                  <p>Web Sitesi, Türkiye genelinde 5846 sayılı Fikir ve Sanat Eserleri Kanunu uyarınca ve dünya çapında uluslararası sözleşmeler, telif yasaları ve düzenlemeleri uyarınca korunmaktadır. Sarıkaya + Şahin’in açık yazılı ön izni olmaksızın Web Sitesi’nin içeriğini, tasarımını veya düzenini veya Web Sitesi’nin bağımsız bir bölümünün içeriğini, tasarımını veya düzenini değiştiremezsiniz, çoğaltamazsınız veya dağıtamazsınız.
                  </p>
                </li><br>
              </ul>
            </span>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'yasal-bildirimler',
    data() {
      return {

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .legalNotices p {
    font-size: 1.5rem;
  }

  #app {
    background: #606c96;
  }

  .legalNotices h1::after {
    content: "";
    position: absolute;
    height: 5px;
    bottom: 0;
    left: 0;
    width: 40%;
    background: #81A716;
  }

  .legalNotices h1 {
    position: relative;
    color: #504f50;
    font-family: 'SEC', sans-serif;
  }

  .legalNotices h3 {
    position: relative;
    color: #504f50;
    font-size: 30px;
  }

  small {
    font-size: 1.2rem;
    font-weight: 900;
    text-transform: uppercase;
    display: inline-block;
    padding-bottom: 20px;
  }

  .legalNotices ul li {
    text-align: justify;
    list-style: none;
  }
</style>



// WEBPACK FOOTER //
// yasal-bildirimler.vue?43d247a6